// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2nPql","right":"styles_right__3NyWh"};